import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"
import articlesData from '../data/ShopItems.json';

const Carousel = () => {
  const selectedIds = [1, 6, 7, 8, 9, 10];

  // Filtrez les articles
  const filteredArticles = articlesData.filter(article => 
    selectedIds.includes(article.id)
  );

  const settings = {
    focusOnSelect: true,
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 3,
    speed: 500,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          centerPadding: "40px",
          swipe: true,
          dots: true,
          arrows: false,
          swipeToSlide: true,
          touchThreshold: 10,
          lazyLoad: true
        }
      },
      {
        breakpoint: 1024,
        settings: {
          centerMode: true,
          slidesToShow: 3,
          centerPadding: "60px",
          swipe: false,
          dots: false,
          arrows: true,
          swipeToSlide: false,
          touchThreshold: 10,
          lazyLoad: true
        }
      }
    ]
  };

    return (
      <div className="carousel-wrapper" >
        <div>
          <Slider {...settings}>
          {filteredArticles.map((d)=> (
            <div key={d.id}>
              <div className="slide-image">
                <img src={d.image} alt=""/>
              </div>
              <div className="slide-content">
                <h2>{d.title}</h2>
                <p>{d.price} €</p>
              </div>
            </div>
          ))}
          </Slider>
        </div>
      </div>
    );
};

export default Carousel;